<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="modelValue"
        class="fixed inset-0 z-[60] flex items-end justify-center bg-slate-900/50 p-0 backdrop-blur-sm sm:items-center sm:p-4"
        @mousedown.self="requestClose"
      >
        <Transition name="pop" appear>
          <div
            ref="panel"
            role="dialog"
            aria-modal="true"
            :aria-label="title"
            tabindex="-1"
            class="flex max-h-[92vh] w-full flex-col rounded-t-3xl bg-white shadow-2xl outline-none dark:bg-slate-800 sm:rounded-3xl"
            :class="widths[size]"
            @keydown.esc.stop="requestClose"
          >
            <header class="flex items-start justify-between gap-4 border-b border-slate-100 px-6 py-5 dark:border-slate-700">
              <div class="min-w-0">
                <h2 class="truncate text-lg font-bold text-slate-900 dark:text-slate-100">{{ title }}</h2>
                <p v-if="subtitle" class="mt-0.5 text-sm text-slate-500 dark:text-slate-400">{{ subtitle }}</p>
              </div>
              <button type="button" class="btn-icon -mr-2 -mt-1" aria-label="Fermer" @click="requestClose">
                <AppIcon name="x" />
              </button>
            </header>
            <div class="overflow-y-auto px-6 py-5">
              <slot />
            </div>
            <footer v-if="$slots.footer" class="flex flex-wrap justify-end gap-2 border-t border-slate-100 px-6 py-4 dark:border-slate-700">
              <slot name="footer" />
            </footer>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'AppModal',
  components: { AppIcon },
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    size: { type: String, default: 'md' },
    /** Empêche la fermeture (envoi en cours). */
    persistent: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'close'],
  data() {
    return { widths: { sm: 'sm:max-w-md', md: 'sm:max-w-xl', lg: 'sm:max-w-3xl', xl: 'sm:max-w-5xl' } }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(open) {
        document.body.style.overflow = open ? 'hidden' : ''
        if (open) this.$nextTick(() => this.$refs.panel && this.$refs.panel.focus())
      }
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  },
  methods: {
    requestClose() {
      if (this.persistent) return
      this.$emit('update:modelValue', false)
      this.$emit('close')
    }
  }
}
</script>
